module.exports = __webpack_public_path__ + "assets/img/unpaid.93636b91.png";